var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "se-cont" }, [
    _vm.processing
      ? _c("div", { staticClass: "loading" }, [_c("dots-loader")], 1)
      : _vm._e(),
    _vm._v(" "),
    _vm.fetchCompleted
      ? _c("div", { staticClass: "se-wrapper self-exclusion-v2" }, [
          _c("div", { staticClass: "initial-screen" }, [
            _c("div", { staticClass: "se-chld-header" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("Account.Exclusions.SE.Header")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "se-chld-info" }, [
              _c("div", [
                _vm._v(
                  _vm._s(_vm.$t("Account.Exclusions.SE.InitScreen.Desc.One"))
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.$t("Account.Exclusions.SE.InitScreen.Desc.Two"))
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "se-chld-ctacont", class: { dge: _vm.isNJ } },
              [
                _vm.isNJ
                  ? _c(
                      "div",
                      {
                        staticClass: "se-dge",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.openDGEUrl.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("Account.Exclusions.SE.DGE")))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "se-chld-btns" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "primary-btn",
                        attrs: { color: "success" },
                        on: {
                          click: function($event) {
                            return _vm.apply()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Account.Exclusions.Apply")))]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d9ae06a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9ae06a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Exclusions/SelfExclusion.vue
// module id = null
// module chunks = 